const _excluded = ["content", "projectSettings", "countrySpecificFooterDisclaimer", "siteConfig", "path", "onSearch", "templateWidth", "applicationSettingsExtraProps", "componentMap"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { CMSContent } from '@cbhq/cdx-components';
import { getEntryProps } from '../../utils/getEntryProps.js';
import { PageTemplateLayout } from '../PageTemplateLayout.js';
import { PageTemplateProviders } from '../PageTemplateProviders.js';
import { jsx } from 'react/jsx-runtime';
const LANDING_TEMPLATE_CONTENT_MODEL_ID = 'cdxTemplateLandingPage';
function LandingTemplate(_ref) {
  let content = _ref.content,
    projectSettings = _ref.projectSettings,
    countrySpecificFooterDisclaimer = _ref.countrySpecificFooterDisclaimer,
    siteConfig = _ref.siteConfig,
    path = _ref.path,
    onSearch = _ref.onSearch,
    templateWidth = _ref.templateWidth,
    applicationSettingsExtraProps = _ref.applicationSettingsExtraProps,
    componentMap = _ref.componentMap,
    pageTemplateProviderProps = _objectWithoutProperties(_ref, _excluded);
  const _getEntryProps = getEntryProps(projectSettings),
    productId = _getEntryProps.productId,
    fallbackImage = _getEntryProps.fallbackImage;
  const fallbackImageUrl = fallbackImage?.fields.file.url;
  const fallbackImageAlt = fallbackImage?.fields.title;
  return /*#__PURE__*/jsx(PageTemplateProviders, _objectSpread(_objectSpread({
    siteConfig: siteConfig,
    componentMap: componentMap
  }, pageTemplateProviderProps), {}, {
    children: /*#__PURE__*/jsx(PageTemplateLayout, {
      siteConfig: siteConfig,
      projectConfig: projectSettings,
      path: path,
      templateWidth: templateWidth,
      onSearch: onSearch,
      applicationSettingsExtraProps: applicationSettingsExtraProps,
      children: /*#__PURE__*/jsx(CMSContent, {
        content: content || [],
        additionalProps: {
          productId,
          fallbackImageAlt,
          fallbackImageUrl
        }
      })
    })
  }));
}
export { LANDING_TEMPLATE_CONTENT_MODEL_ID, LandingTemplate };
//# sourceMappingURL=LandingTemplate.js.map
